const creditCardCvcValidadMask = value => {
  if (!value) {
    return value
  }

  const onlyNums = value.replace(/[^\d]/g, '')

  if (onlyNums.length <= 3) {
    return `${onlyNums.slice(0, 3)}`
  }
}

export default creditCardCvcValidadMask



// WEBPACK FOOTER //
// ./src/alelo-logic/utils/creditCardCvcValidadMask.js